import { GROUP_ID } from "@/constant/group";
import { CancelToken } from "axios";
import { moimAPI } from ".";

export async function getComponentLayout(
  id: Moim.Id,
  type: string,
  platform?: string,
  userId?: Moim.Id,
  cancelToken?: CancelToken,
) {
  return await moimAPI.request<
    Promise<Moim.ISingleItemResponse<Moim.Component.IComponentLayout>>
  >({
    method: "GET",
    url: `/component_layouts/${id}`,
    params: { type, platform, userId },
    cancelToken,
  });
}

export async function getChildMoimGroup(
  id: Moim.Id,
  cancelToken?: CancelToken,
) {
  return await moimAPI.request<
    Promise<Moim.ISingleItemResponse<Moim.ChildMoimGroup.IChildMoimGroupData>>
  >({
    method: "GET",
    url: `/groups/${GROUP_ID}/child_moim_groups/${id}`,
    cancelToken,
  });
}

export async function getChildMoimGroupMoims(
  id: Moim.Id,
  limit: number = 30,
  cancelToken?: CancelToken,
  paging?: { from?: string; after?: string },
  sort?: string,
  desc?: "asc" | "desc",
) {
  return await moimAPI.request<
    Promise<
      Moim.IPaginatedListResponse<Moim.ChildMoimGroup.IChildMoimGroupMoimRawDatum>
    >
  >({
    method: "POST",
    url: `/groups/${GROUP_ID}/child_moim_groups/${id}/groups`,
    data: {
      query: {
        limit,
        ...paging,
        sort,
        desc,
      },
    },
    cancelToken,
  });
}

export async function updateProfile(
  profile: Moim.User.IUpdatableInfo,
  cancelToken?: CancelToken,
) {
  return await moimAPI.request<
    Promise<Moim.ISingleItemResponse<Moim.User.IUser>>
  >({
    method: "PUT",
    url: `/me`,
    data: { profile },
    cancelToken,
  });
}

export async function getBoot(cancelToken?: CancelToken) {
  return await moimAPI.request<
    Promise<Moim.ISingleItemResponse<Moim.Group.IBootstrap>>
  >({
    method: "POST",
    url: `groups/${GROUP_ID}/boot`,
    cancelToken,
  });
}
